export const categories = [
  {
    slug: "yule-mengliao",
    name: "娱乐猛料",
    description: "娱乐圈最新八卦、明星塌房内幕、综艺节目黑料爆料，一网打尽不放过任何猛料。",
    icon: "ri-flashlight-line",
    count: 156,
  },
  {
    slug: "wanghong-tafang",
    name: "网红塌房",
    description: "追踪网红翻车现场、网红人设崩塌实录、直播翻车名场面，每日更新塌房实况。",
    icon: "ri-building-2-line",
    count: 89,
  },
  {
    slug: "shehui-qiwen",
    name: "社会奇闻",
    description: "社会热点事件追踪、奇葩新闻爆料、网络热门话题深度解析，带你吃瓜吃到饱。",
    icon: "ri-earth-line",
    count: 203,
  },
  {
    slug: "zhibo-chigua",
    name: "直播吃瓜",
    description: "各大平台直播名场面合集、主播互撕录屏、直播间翻车精彩瞬间实时追踪。",
    icon: "ri-live-line",
    count: 67,
  },
  {
    slug: "mingxing-bagua",
    name: "明星八卦",
    description: "明星恋情曝光、明星私生活揭秘、综艺录制花絮爆料，全方位吃瓜明星圈。",
    icon: "ri-star-line",
    count: 178,
  },
  {
    slug: "shenye-heiliao",
    name: "深夜黑料",
    description: "深夜档重磅爆料、不可描述的名场面、那些年被删掉的劲爆内容，深夜专属。",
    icon: "ri-moon-line",
    count: 45,
  },
];

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImageUrl: string;
  author: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    slug: "dingji-wanghong-beihou-zhinao-jiexi",
    title: "某千万粉网红背后的操盘团队被扒！原来人设全是演的？",
    excerpt: "一位拥有千万粉丝的头部网红近日被扒出其背后存在专业操盘团队，从人设打造到剧本设计全程策划。粉丝们惊呼：原来关注的网红全是演员！",
    content: "",
    category: "wanghong-tafang",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20social%20media%20influencer%20set%20with%20cameras%20and%20lighting%20equipment%20behind%20the%20scenes%2C%20the%20influencer%20looking%20fake%20and%20staged%2C%20cinematic%20lighting%20with%20warm%20amber%20tones%2C%20editorial%20photography%20style%2C%20mysterious%20atmosphere%20with%20dark%20background%2C%20soft%20shadows%20and%20dramatic%20composition%2C%20high%20detail%20texture%20on%20equipment&width=800&height=500&seq=article-cover-01&orientation=landscape",
    author: "吃瓜前线记者",
    publishDate: "2026-07-06",
    readCount: 128500,
    commentCount: 3621,
    tags: ["网红塌房", "人设崩塌", "幕后操盘", "千万粉丝"],
    isHot: true,
    isExclusive: true,
  },
  {
    slug: "zhibo-daihuo-fanche-xianchang",
    title: "直播带货翻车名场面合集：这些主播的操作简直离谱到家",
    excerpt: "近期多位知名带货主播在直播间连续翻车，从虚假宣传被当场揭穿到产品质量问题曝光，网友直呼：这瓜吃得太过瘾了！",
    content: "",
    category: "zhibo-chigua",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20live%20streaming%20ecommerce%20studio%20in%20chaos%2C%20products%20scattered%20everywhere%2C%20a%20streamer%20looking%20embarrassed%20and%20shocked%2C%20red%20alert%20notification%20on%20screen%2C%20dramatic%20lighting%20with%20warm%20spotlight%2C%20editorial%20photography%2C%20high%20contrast%20shadows%2C%20cinematic%20composition%20with%20depth%20of%20field&width=800&height=500&seq=article-cover-02&orientation=landscape",
    author: "直播间观察员",
    publishDate: "2026-07-05",
    readCount: 96500,
    commentCount: 2890,
    tags: ["直播翻车", "带货事故", "虚假宣传", "现场直击"],
    isHot: true,
    isExclusive: false,
  },
  {
    slug: "nvyouxizhubo-beiju-neimu",
    title: "女游戏主播被曝私下与榜一大哥秘密约会，聊天记录流出",
    excerpt: "某知名游戏女主播被前助理爆料与多位榜一大哥存在私下往来，多张聊天截图和转账记录在网上疯传，引发网友热议。",
    content: "",
    category: "yule-mengliao",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20mysterious%20scene%20showing%20a%20gaming%20streamer%20setup%20with%20dim%20ambient%20lighting%2C%20chat%20bubbles%20floating%20on%20a%20dark%20screen%2C%20silhouette%20of%20a%20female%20figure%20in%20front%20of%20monitors%2C%20dramatic%20noir%20atmosphere%2C%20cinematic%20lighting%20with%20pink%20and%20blue%20neon%20accents%2C%20editorial%20photography%2C%20moody%20and%20suspenseful%20tone&width=800&height=500&seq=article-cover-03&orientation=landscape",
    author: "游戏圈八卦王",
    publishDate: "2026-07-05",
    readCount: 152300,
    commentCount: 5120,
    tags: ["女主播", "榜一大哥", "聊天记录", "私密约会"],
    isHot: true,
    isExclusive: true,
  },
  {
    slug: "duanshipin-hongren-juben-chaoxi",
    title: "短视频平台两大人气创作者互撕，竟是因为剧本抄袭？",
    excerpt: "拥有各自千万粉丝的两大短视频创作者近日在平台隔空互怼，互相指责对方抄袭自己的剧本创意，粉丝战队混战一触即发。",
    content: "",
    category: "yule-mengliao",
    coverImageUrl: "https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20each%20other%20on%20a%20dark%20table%2C%20both%20showing%20social%20media%20feeds%20with%20angry%20reaction%20emojis%2C%20dramatic%20split%20lighting%20with%20warm%20and%20cool%20tones%20on%20each%20side%2C%20editorial%20photography%2C%20tense%20atmosphere%2C%20high%20contrast%2C%20cinematic%20composition&width=800&height=500&seq=article-cover-04&orientation=landscape",
    author: "短视频侦探",
    publishDate: "2026-07-04",
    readCount: 87300,
    commentCount: 2340,
    tags: ["短视频", "创作者互撕", "剧本抄袭", "粉丝混战"],
    isHot: false,
    isExclusive: false,
  },
  {
    slug: "wangluohongren-ruanjian-zaojia",
    title: "爆料！某网红晒出的奢侈品竟然全是高仿？鉴定师实锤了",
    excerpt: "一位经常在社交平台晒大牌包包的网红被专业鉴定师实锤，其展示的多款奢侈品均为高仿产品，人设彻底崩塌。",
    content: "",
    category: "wanghong-tafang",
    coverImageUrl: "https://readdy.ai/api/search-image?query=Luxury%20handbags%20displayed%20under%20a%20magnifying%20glass%20with%20a%20red%20fake%20stamp%20mark%2C%20elegant%20dark%20background%20with%20dramatic%20spotlight%2C%20forensic%20investigation%20aesthetic%2C%20editorial%20photography%2C%20high%20detail%20on%20bag%20textures%2C%20moody%20and%20suspenseful%20lighting&width=800&height=500&seq=article-cover-05&orientation=landscape",
    author: "奢侈品鉴定师",
    publishDate: "2026-07-04",
    readCount: 110200,
    commentCount: 4560,
    tags: ["奢侈品", "高仿曝光", "人设崩塌", "鉴定实锤"],
    isHot: true,
    isExclusive: true,
  },
  {
    slug: "shejiao-meiti-zhengzhi-zhengyi",
    title: "社交平台大V因争议言论遭全网封杀，账号一夜消失",
    excerpt: "一位拥有数百万粉丝的社交平台大V因发表不当言论引发众怒，多个平台在深夜同步封禁其账号，网友拍手称快。",
    content: "",
    category: "shehui-qiwen",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20suspended%20account%20notice%20with%20red%20warning%20icon%2C%20the%20phone%20lying%20on%20a%20dark%20desk%20with%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20tense%20and%20ominous%20atmosphere%2C%20high%20contrast%2C%20cold%20blue%20undertones&width=800&height=500&seq=article-cover-06&orientation=landscape",
    author: "平台观察家",
    publishDate: "2026-07-03",
    readCount: 201400,
    commentCount: 8930,
    tags: ["账号封禁", "争议言论", "全网封杀", "大V翻车"],
    isHot: true,
    isExclusive: false,
  },
  {
    slug: "shenye-jijianhui-jingbao-neimu",
    title: "深夜档爆料：某选秀节目选手私下关系曝光，原来都是演的",
    excerpt: "知情人士深夜投稿爆料，某热门选秀节目中看似关系亲密的选手私下竟互不理睬，台上姐妹情深全是节目组安排的剧本。",
    content: "",
    category: "shenye-heiliao",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20dark%20backstage%20of%20a%20talent%20show%20with%20two%20contestants%20turning%20away%20from%20each%20other%2C%20dramatic%20split%20lighting%2C%20one%20in%20warm%20spotlight%20and%20one%20in%20cold%20shadow%2C%20theatrical%20stage%20curtains%20in%20background%2C%20editorial%20photography%2C%20cinematic%20composition%2C%20high%20emotional%20tension&width=800&height=500&seq=article-cover-07&orientation=landscape",
    author: "深夜瓜农",
    publishDate: "2026-07-03",
    readCount: 67500,
    commentCount: 1890,
    tags: ["选秀节目", "选手关系", "剧本安排", "深夜爆料"],
    isHot: false,
    isExclusive: true,
  },
  {
    slug: "mingxing-qinglv-beiju-fenshou",
    title: "娱乐圈模范情侣疑似分手？双方已互相取关社交媒体",
    excerpt: "被粉丝称为娱乐圈模范情侣的两位明星近日被眼尖网友发现互相取关了所有社交平台，疑似感情生变。知情人透露更多细节。",
    content: "",
    category: "mingxing-bagua",
    coverImageUrl: "https://readdy.ai/api/search-image?query=Two%20smartphones%20on%20a%20dark%20surface%20showing%20unfollowed%20social%20media%20profiles%20with%20a%20cracked%20heart%20symbol%20between%20them%2C%20dramatic%20lighting%20with%20warm%20and%20cold%20split%20tones%2C%20editorial%20photography%2C%20emotional%20and%20melancholic%20atmosphere%2C%20soft%20shadows%2C%20cinematic%20composition&width=800&height=500&seq=article-cover-08&orientation=landscape",
    author: "娱乐圈老司机",
    publishDate: "2026-07-02",
    readCount: 189000,
    commentCount: 6780,
    tags: ["明星情侣", "分手疑云", "互相取关", "感情生变"],
    isHot: true,
    isExclusive: false,
  },
  {
    slug: "shangye-hezuo-beipan-neimu",
    title: "网红合伙人翻脸内幕：从亲密无间到对簿公堂的全过程",
    excerpt: "一对曾经被誉为网红合伙创业标杆的搭档近日因利益分配问题反目成仇，双方在社交平台隔空对骂，甚至已经走到了法律程序。",
    content: "",
    category: "wanghong-tafang",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20torn%20business%20contract%20on%20a%20dark%20wooden%20desk%2C%20two%20chairs%20facing%20away%20from%20each%20other%20in%20the%20background%2C%20dramatic%20lighting%20with%20harsh%20shadows%2C%20editorial%20photography%2C%20tense%20atmosphere%2C%20legal%20documents%20scattered%2C%20cinematic%20composition%20with%20depth&width=800&height=500&seq=article-cover-09&orientation=landscape",
    author: "商业吃瓜人",
    publishDate: "2026-07-02",
    readCount: 78300,
    commentCount: 2150,
    tags: ["网红合伙", "利益纠纷", "反目成仇", "法律诉讼"],
    isHot: false,
    isExclusive: true,
  },
  {
    slug: "wangluo-baoliao-pingtai-tougao-zengzhang",
    title: "平台内部人士曝光：热搜榜单竟然可以花钱买位置？价格表流出",
    excerpt: "一位自称某社交平台前员工的匿名人士爆料称平台热搜榜存在明码标价的买卖行为，并附上了详细的价目表和操作流程截图。",
    content: "",
    category: "shehui-qiwen",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20leaked%20price%20list%20document%20on%20a%20dark%20desk%20illuminated%20by%20a%20single%20desk%20lamp%2C%20showing%20social%20media%20trending%20hashtag%20rankings%20with%20prices%2C%20dramatic%20noir%20lighting%2C%20editorial%20photography%2C%20whistleblower%20aesthetic%2C%20tense%20and%20secretive%20atmosphere&width=800&height=500&seq=article-cover-10&orientation=landscape",
    author: "匿名线人",
    publishDate: "2026-07-01",
    readCount: 231500,
    commentCount: 10240,
    tags: ["热搜买卖", "内部爆料", "价目表", "平台内幕"],
    isHot: true,
    isExclusive: true,
  },
  {
    slug: "zhiming-zhubo-bofangliang-zaojia",
    title: "知名主播被扒直播间人数造假，后台真实数据惨不忍睹",
    excerpt: "技术网友通过对某知名主播直播间的数据包抓取分析，发现其显示的在线人数与实际观看人数相差数十倍，造假手段被逐一拆解。",
    content: "",
    category: "zhibo-chigua",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20computer%20screen%20showing%20data%20analytics%20charts%20with%20red%20fake%20data%20indicators%2C%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20hacker%20investigation%20aesthetic%2C%20editorial%20photography%2C%20technical%20and%20forensic%20mood%2C%20green%20matrix-like%20data%20streams%20in%20background&width=800&height=500&seq=article-cover-11&orientation=landscape",
    author: "数据打假人",
    publishDate: "2026-07-01",
    readCount: 104600,
    commentCount: 3450,
    tags: ["数据造假", "直播间", "后台真实数据", "技术扒皮"],
    isHot: true,
    isExclusive: false,
  },
  {
    slug: "nvmingxing-zhengrong-qianhou-duibi",
    title: "女星整容前后对比照被扒，网友：这是同一个人？",
    excerpt: "近日一组某当红女星的整容前后对比照在网上疯传，从五官到脸型变化巨大，引发网友对娱乐圈整容风气的热议。",
    content: "",
    category: "mingxing-bagua",
    coverImageUrl: "https://readdy.ai/api/search-image?query=A%20split%20before%20and%20after%20comparison%20aesthetic%20with%20a%20dramatic%20makeup%20mirror%20in%20the%20center%2C%20dark%20elegant%20background%2C%20soft%20glamorous%20lighting%20on%20one%20side%20and%20harsh%20revealing%20light%20on%20the%20other%2C%20editorial%20photography%2C%20fashion%20magazine%20style%2C%20beauty%20and%20transformation%20theme&width=800&height=500&seq=article-cover-12&orientation=landscape",
    author: "颜值鉴定官",
    publishDate: "2026-06-30",
    readCount: 276800,
    commentCount: 12450,
    tags: ["整容对比", "女星颜值", "前后变化", "娱乐圈"],
    isHot: true,
    isExclusive: false,
  },
];

export const heroHighlights = [
  {
    slug: "dingji-wanghong-beihou-zhinao-jiexi",
    title: "千万粉网红操盘团队被扒",
    excerpt: "人设全是演的？幕后团队全程策划曝光",
    color: "from-primary-500/90 to-primary-600/90",
  },
  {
    slug: "nvyouxizhubo-beiju-neimu",
    title: "女游戏主播私密聊天曝光",
    excerpt: "与榜一大哥私下往来，转账记录流出",
    color: "from-accent-500/90 to-accent-600/90",
  },
  {
    slug: "shejiao-meiti-zhengzhi-zhengyi",
    title: "百万大V因争议言论被封",
    excerpt: "全网平台同步封禁，账号一夜蒸发",
    color: "from-secondary-500/90 to-secondary-600/90",
  },
  {
    slug: "zhiming-zhubo-bofangliang-zaojia",
    title: "知名主播人数造假被扒",
    excerpt: "真实数据惨不忍睹，相差数十倍",
    color: "from-primary-600/90 to-accent-500/90",
  },
  {
    slug: "mingxing-qinglv-beiju-fenshou",
    title: "模范情侣互相取关疑分手",
    excerpt: "社交媒体全面取关，感情生变",
    color: "from-accent-500/90 to-secondary-500/90",
  },
];